import React from 'react';
import { useMediaBreakpoint } from '@americanexpress/consumer-travel-base';
import PropTypes from 'prop-types';
import AbandonHotelMobile from './Mobile/AbandonHotelMobile';
import AbandonHotelDesktop from './Desktop/AbandonHotelDesktop';
import { useIsCenturionContext } from '../../context/isCenturionContext';
import { useAbandonCartData } from '../../hooks/useContextApiHook';
import { useFeatureFlagWithProperties } from '../../thunks/useFeatureFlagWithProperties';
import { ABANDON_CART_FF } from '../../constants/oneXpConstants';
import { hasValidAbandonCartData } from '../../utils/abandonCartUtils';

const AbandonHotel = ({ extraDlsStyles = '' }) => {
  const isDesktop = useMediaBreakpoint('lg-up');
  const hasDisplayAbandonHotel = useFeatureFlagWithProperties(ABANDON_CART_FF);
  const isCenturion = useIsCenturionContext();
  const { data: abandonCartData, error, isLoading } = useAbandonCartData();

  if (
    hasDisplayAbandonHotel
    && !isCenturion
    && !error
    && !isLoading
    && hasValidAbandonCartData(abandonCartData)
  ) {
    return (
      <div id="abandonHotelBanner" className={`container margin-2-t ${extraDlsStyles}`}>
        {isDesktop ? <AbandonHotelDesktop /> : <AbandonHotelMobile />}
      </div>
    );
  }

  return null;
};

AbandonHotel.propTypes = {
  extraDlsStyles: PropTypes.string,
};

export default AbandonHotel;
